// extracted by mini-css-extract-plugin
module.exports = {"content":"e_5","pw-ad-scroll-container":"e_6","pw-in-article":"e_7"};